import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// NOVA interface unificada (substitui LogData)
export interface AuditUnified {
  auditId: number;
  userId: number;
  userShortName: string;
  userCpf: string;
  tableName: string;       // "CREDENTIAL", "PEOPLE", "ADDRESS", etc.
  logType: string;         // "ADDED", "UPDATED", "DELETED", "CANCELED", etc.
  entityId: number;
  afterAction: string;     // JSON com detalhes da ação
  createdAt: string;       // ISO 8601
  source: 'LEGACY' | 'NEW'; // origem dos dados
}

// Interface paginada (Spring Boot Page)
export interface PageableAudit {
  content: AuditUnified[];
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class HistoryService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Consulta unificada de histórico (tb_log_data legado + tb_audit_entry novo)
   */
  getAuditByPeriod(
    initialDate: string,
    finalDate: string,
    userId?: number | undefined,
    table?: string | undefined,
    action?: string | undefined,
    page: number = 0,
    size: number = 10
  ): Observable<PageableAudit> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (initialDate) {
      params = params.set('initialDate', initialDate);
    }
    if (finalDate) {
      params = params.set('finalDate', finalDate);
    }
    if (userId) {
      params = params.set('userId', userId.toString());
    }
    if (table) {
      params = params.set('table', table);
    }
    if (action) {
      params = params.set('action', action);
    }

    // NOVO endpoint unificado
    const url = `${this.apiUrl}/sicred/api/v1/audit/period`;
    return this.http.get<PageableAudit>(url, { params: params.set('sort', 'createdAt,desc') });
  }

}